module.exports = __webpack_public_path__ + "static/media/psicologia_isologo.4f20be14.png";